<template>
  <div class="rj-page-card">
    <div class="rj-page-card__content">
      <el-form ref="searchForm" :inline="true" :model="searchForm">
        <el-form-item label="申请单号:" prop="applicationNo">
          <el-input v-model="searchForm.applicationNo" clearable placeholder="申请单号" />
        </el-form-item>
        <el-form-item label="渠道编码:" prop="channelCode">
          <el-input v-model="searchForm.channelCode" clearable placeholder="渠道编码" />
        </el-form-item>
        <el-form-item label="发起类型:" prop="sourceType">
          <el-select v-model="searchForm.sourceType" clearable placeholder="发起类型">
            <el-option
              v-for="item in launchTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间:" prop="submittedStart">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.submittedStart"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.submittedEnd"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                clearable
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="isLoading" @click="searchQueryList">
            查询
          </el-button>
          <el-button type="default" :loading="isLoading" @click="resetForm">
            重置
          </el-button>
        </el-form-item>
      </el-form>

      <div v-loading="isLoading" class="tableBody">
        <el-table ref="table" :data="tableData" border style="width: 100%">
          <el-table-column prop="applicationNo" label="申请单号" align="left" min-width="140">
            <template v-slot="{ row }">
              <el-button type="text" class="el-btn-text-left" @click="handleDetail(row)">
                {{ row.applicationNo }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="submittedAt" label="申请日期" align="left" min-width="150">
            <template v-slot="{ row }">
              <span>{{ row.submittedAt ? formatDate(row.submittedAt) : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="channelCode" label="渠道编码" align="left" min-width="100" />
          <el-table-column prop="channelName" label="渠道名称" align="left" min-width="120" />
          <el-table-column prop="sourceType" label="发起类型" align="left" min-width="110">
            <template v-slot="{ row }">
              <span>{{ row.sourceType === 1 ? '报关台账' : '本地发票' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="applicationAmount" label="申请抵扣金额" min-width="130" />
          <el-table-column prop="currency" label="币种" align="left" min-width="80" />
          <el-table-column prop="applicantName" label="申请人" align="left" min-width="100" />
          <el-table-column prop="applicantId" label="申请人账号" align="left" min-width="140" />
          <el-table-column v-if="type !== 'PENDING'" prop="approvalResult" label="审批状态" align="left" min-width="120">
            <template v-slot="{ row }">
              <span class="status-pill">{{ row.approvalResult === 'APPROVED' ? '通过' : row.approvalResult === 'REJECTED' ? '驳回' : '待审批' }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="type !== 'PENDING'" prop="approvalComment" label="审批意见" align="left" min-width="120">
            <template v-slot="{ row }">
              <el-tooltip
                :content="row.approvalComment"
                placement="top"
                :disabled="!row.approvalComment"
                popper-class="approval-comment-popper"
              >
                <div class="approval-comment-ellipsis">{{ row.approvalComment || '-' }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="100" fixed="right">
            <template v-slot="{ row }">
              <el-button v-if="type === 'PENDING'" type="text" @click="handleApprove(row)">
                审批
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrap">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.currentPage"
            layout="total, prev, pager, next, jumper, sizes"
            :total="page.total"
            hide-on-single-page
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetRebateReceivableList } from '@/API/BatchManagement.js';
import dayjs from 'dayjs';

const DEFAULT_SEARCH_FORM = {
  applicationNo: '',
  channelCode: '',
  sourceType: '',
  submittedStart: '',
  submittedEnd: ''
};

export default {
  name: 'RebateReceivable',

  inject: {
    rootTabs: {
      default: null
    }
  },

  props: {
    type: {
      type: String,
      default: 'PENDING'
    }
  },

  data () {
    return {
      isLoading: false,
      tableData: [],
      searchForm: { ...DEFAULT_SEARCH_FORM },
      launchTypeOptions: [
        { label: '本地发票', value: '2' },
        { label: '报关台账', value: '1' }
      ],
      pickerOptions: {
        disabledDate: (time) => {
          const start = this.searchForm.submittedStart;
          return start ? time.getTime() < new Date(start).getTime() : false;
        }
      },
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },

  computed: {
    currentTabName () {
      return this.rootTabs ? this.rootTabs.currentName : '';
    }
  },

  created () {
    this.queryData();
  },

  watch: {
    // tab 由隐藏切回显示时，表格宽度需要重新计算，否则固定列/列宽会闪烁错位
    currentTabName () {
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.doLayout();
      });
    }
  },

  methods: {
    formatDate (date) {
      return dayjs(date).format('YYYY-MM-DD');
    },

    searchQueryList () {
      this.page.currentPage = 1;
      this.queryData();
    },

    async queryData () {
      this.isLoading = true;
      try {
        const response = await GetRebateReceivableList({
          listType: this.type, // 列表类型，PENDING: 待确认，APPROVED: 已确认
          applicationNo: this.searchForm.applicationNo, // 申请单号
          channelCode: this.searchForm.channelCode, // 渠道编码
          sourceType: this.searchForm.sourceType, // 发起类型
          submittedStart: this.searchForm.submittedStart, // 提交开始时间
          submittedEnd: this.searchForm.submittedEnd, // 提交结束时间
          pageSize: this.page.pageSize,
          pageNum: this.page.currentPage
        });
        const { list = [], total = 0 } = (response.data && response.data.data) || {};
        this.tableData = list;
        this.page.total = total;
      } catch (error) {
        console.error('查询返利抵应收列表失败:', error);
        this.tableData = [];
        this.page.total = 0;
      } finally {
        this.isLoading = false;
      }
    },

    resetForm () {
      this.$refs.searchForm && this.$refs.searchForm.resetFields();
      Object.assign(this.searchForm, DEFAULT_SEARCH_FORM);
      this.page.currentPage = 1;
      this.queryData();
    },

    handleSizeChange () {
      this.page.currentPage = 1;
      this.queryData();
    },

    handleCurrentChange () {
      this.queryData();
    },

    handleApprove (row) {
      this.$router.push({
        name: 'RebateReceivableApproval',
        params: {
          contractNum: row.applicationNo
        },
        query: {
          type: 'approval',
          tab: this.type === 'PENDING' ? '3' : '4'
        }
      });
    },
    handleDetail (row) {
      this.$router.push({
        name: 'RebateReceivableApproval',
        params: {
          contractNum: row.applicationNo
        },
        query: {
          type: 'view',
          tab: this.type === 'PENDING' ? '3' : '4'
        }
      });
    }
  }
};
</script>

<style scoped>
.pagination-wrap {
  margin-top: 10px;
  text-align: right;
}

.status-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  background: #ecf5ff;
  color: #409eff;
  line-height: 20px;
}

/* 审批意见超长省略号，完整内容通过气泡展示 */
.approval-comment-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>

<style>
/* 气泡挂载在 body 下，需全局样式：保留换行并限制最大宽度 */
.approval-comment-popper {
  max-width: 400px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
